/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { CircularProgress } from "@material-ui/core";

import "./style.css";
import { putRequest } from "utils/request";

import { i18n } from '../../../translate/i18n';
import { useModal } from "hooks/modal";
import {Tooltip } from "@material-ui/core";

import { getRequest } from "utils/request";
import format from "utils/dateFormat";

export default function SatisfactionDetails({
  selectedevaluation,
  handleGoBack,
  handleUpdate,
  selectedCompany
}) {
  const [loading, setLoading] = useState(false);
  const [replica, setReplica] = useState("");
  const [ticket, setTicket] = useState([])
  const { toggleHelperId} = useModal();

  useEffect(() => {
    setReplica(selectedevaluation.reply);
    toggleHelperId(16);
    getConversation();
  }, []);

  const getConversation = async () => {
    const { data } = await getRequest(`/tickets/${selectedevaluation.Ticket.id}`)
    setTicket(data);
  }

  const handleSubimit = (action) => {
    setLoading(true);

    let submit = "";

    if (action === 1) {
      submit = `/satisfactionsurveys/approve/${selectedevaluation.id}`;
    } else {
      submit = `/satisfactionsurveys/reject/${selectedevaluation.id}`;
    }

    putRequest(submit, {
        reply: replica,
      })
      .then(function (response) {
        handleUpdate();
        setLoading(false);
        }
      )
  };

  return (
    <>
      {!loading ? (
        <div className="satisfaction-details-container">
          <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div className="infos-column">
              <div className="infos-row">
                <label className="infos-label">{i18n.t('user')}</label>
                <div className="card-info">{selectedevaluation.Ticket.Customer.nickName ?? selectedevaluation.Ticket.Customer.name}</div>
              </div>

              {selectedCompany.id === Number(process.env.REACT_APP_SKUTE_ID) &&
                <div className="infos-row">
                  <label className="infos-label">{i18n.t('company')}</label>
                  <div className="card-info">{selectedevaluation.Ticket.Company.nickName}</div>
                </div>
              }

              <div className="infos-row">
                <label className="infos-label">Ticket</label>
                <div className="card-info">{selectedevaluation.Ticket.ticket}</div>
              </div>

              <div className="infos-row">
                <label className="infos-label">{i18n.t('ticketType')}</label>
                <div className="card-info">{ticket?.CompanyTicketType?.description}</div>
              </div>

              <div className="infos-row">
                <label className="infos-label">{i18n.t('assessments')}</label>
                <div className="card-info">{selectedevaluation.scoreDescription}</div>
              </div>

              <div className="infos-row">
                <label className="infos-label">{i18n.t('backToBusiness')}</label>
                <div className="card-info">{selectedevaluation.goBackBusinessDescription}</div>
              </div>

              <div className="infos-row">
                <label className="infos-label">{i18n.t('comentary')}</label>
                <div className="card-info">{selectedevaluation.message}</div>
              </div>

              <div className="infos-row">
                <label className="infos-label">{i18n.t('replic')}</label>
                <textarea
                  type="text"
                  className="form-control"
                  style={{resize: 'none'}}
                  rows="4"
                  value={replica}
                  onChange={(value) => setReplica(value.target.value)}
                />
              </div>
            </div>
            <div style={{width: 50}}></div>
            <div style={{width: '100%'}}>
              <div className="card" style={{height: '100%', width: '100%' }}>
                <div className="container-area-chat-list">
                  <ul
                    className="conversation-list"
                    data-simplebar="init"
                    style={{
                      display: "flex",
                      height: "100%",
                      width: "100%",
                      marginBottom: 0,
                    }}
                  >
                    <div className="simplebar-wrapper" style={{ margin: 0 - 15}}>
                      <div className="simplebar-mask">
                        <div
                          className="simplebar-offset"
                          style={{ right: 0, bottom: 0 }}
                        >
                          <div
                            className="text-scroll"
                          >
                            {ticket.TicketHistories ? (
                              <div
                                className="simplebar-content"
                                style={{ padding: 15 }}
                                //corrigir  0 15
                              >
                                {ticket.TicketHistories.map((data) => (
                                  <>
                                    {data.visible && (
                                      <div key={data.id}>
                                        <li
                                        style={{ paddingRight: !data.senderUser &&  10 }}
                                          className={
                                            data.senderUser
                                              ? "clearfix"
                                              : "clearfix odd" 
                                          }
                                        >
                                          <Tooltip 
                                            arrow
                                            i
                                            title={ 
                                              data.senderUser ? 
                                              ticket.Customer.name : 
                                              ticket.User ? 
                                              ticket.User.nickName : 
                                              ticket.Company.name
                                            } 
                                            placement="top"
                                          >
                                            <div className="chat-avatar">
                                              <img
                                                src={
                                                    data.senderUser
                                                    ? ticket.Customer.photo
                                                    : ticket.User
                                                    ? ticket.User.photo
                                                    : ticket.Company.photo
                                                }
                                                className="rounded"
                                                alt="avatar-company"
                                              />
                                              <i>
                                                {format(
                                                data.updatedAt,
                                                  "HH:mm"
                                                )}
                                              </i>
                                            </div>
                                          </Tooltip>
                                          <div className="conversation-text">
                                            {data.typeFileId === 1 ? (
                                              <div style={{minHeight: 40, maxWidth: '80%'}} className="ctext-wrap">
                                                <div
                                                  dangerouslySetInnerHTML={{
                                                    __html: data.message
                                                      .split("\n")
                                                      .join("<br/>"),
                                                  }}
                                                ></div>
                                              </div>
                                            ) : (
                                              <>
                                                {data.typeFileId === 2 ? (
                                                  <div
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      window.open(
                                                        `${data.pathFile}`,
                                                        "_blank"
                                                      )
                                                    }
                                                  >
                                                    <div className="card mb-1 shadow-none border text-left">
                                                      <div className="p-2">
                                                        <div className="row align-items-center">
                                                          <div className="col-auto">
                                                            <div className="avatar-sm">
                                                              <span className="avatar-title rounded">
                                                                {i18n.t('archive')}
                                                              </span>
                                                            </div>
                                                          </div>
                                                          <div className="col pl-0">
                                                            <a
                                                              href="#"
                                                              className="text-muted font-weight-bold"
                                                            >
                                                              {data.nameFile}
                                                            </a>
                                                            {/*<p className="mb-0">
                                                                      2.3 MB
                                                                    </p> */}
                                                          </div>
                                                          <div className="col-auto">
                                                            <a
                                                              href="#"
                                                              className="btn btn-link btn-lg text-muted"
                                                            >
                                                              <i className="dripicons-download"></i>
                                                            </a>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <>
                                                    {data.typeFileId === 3 ? (
                                                      <div className="p-0">
                                                        <img
                                                          alt=""
                                                          className="img-chat-company-talk"
                                                          src={data.pathFile}
                                                          // onClick={() =>
                                                          //   togglePhotoModal(data.pathFile)
                                                          // }
                                                        />
                                                      </div>
                                                    ) : (
                                                      <>
                                                        {data.typeFileId === 4 ? (
                                                          <div className="p-0">
                                                            <video
                                                              controls
                                                              style={{height: 200}}
                                                              controlsList="nodownload"
                                                              className="img-chat-company-talk"
                                                              src={data.pathFile}
                                                            />
                                                          </div>
                                                        ) : (
                                                          <div className="p-0">
                                                            <audio
                                                              controls
                                                              style={{minHeight: 60}}
                                                              controlsList="nodownload"
                                                              src={data.pathFile}
                                                            />
                                                          </div>
                                                        )}
                                                      </>
                                                    )}
                                                  </>
                                                )}
                                              </>
                                            )}
                                          </div>
                                        </li>
                                      </div>
                                    )}
                                  </>
                                ))}
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="button-list mt-3">
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={() => handleGoBack()}
              >
                <i i className="mdi mdi-backup-restore"></i>
                {i18n.t('getBack')}
              </button>
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => handleSubimit(2)}
              >
                <i i className="mdi mdi-minus-box-outline"></i>
                {i18n.t('reject')}
              </button>
              <button
                type="button"
                className="btn btn-outline-success"
                onClick={() => handleSubimit(1)}
              >
                {" "}
                <i className="mdi mdi-checkbox-marked-circle"></i>{i18n.t('approve')}
              </button>
            </div>
            <label className="mt-3" style={{ color: "red" }}>
              {i18n.t('comentaryRejected')}
            </label>
        </div>
      ) : (
        <div className="area-loading-satisfaction-details">
          <CircularProgress />
        </div>
      )}
    </>
  );
}
